import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/meh-blank': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 176C150.3 176 136 190.3 136 208S150.3 240 168 240 200 225.7 200 208 185.7 176 168 176zM328 176C310.3 176 296 190.3 296 208S310.3 240 328 240 360 225.7 360 208 345.7 176 328 176z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/meh-blank.js
// module id = nuhB
// module chunks = 144